import React from 'react';

import { Radio, Space } from 'antd';

import * as recurrence from '../../../constants/recurrence-constants';

const EventEditDeleteConfirmContent = ({ onChangeType, confirmType }) => {
  return (
    <Radio.Group defaultValue={confirmType} onChange={($event) => onChangeType($event.target.value)}>
      <Space direction="vertical">
        {recurrence.EDIT_EVENT_TYPE_OPTIONS.map((option) => (
          <Radio key={option.value} value={option.value} title={option.title}>
            {option.title}
          </Radio>
        ))}
      </Space>
    </Radio.Group>
  );
};
export default EventEditDeleteConfirmContent;
